var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBrandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "white",
    stroke: "#D2D0D5",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8644 18H9.72182L6.92689 13.957H6.87855V18H5.56019V11.6367H6.72035L9.4933 15.6753H9.55043V11.6367H10.8644V18ZM11.5898 11.6367H15.8613V12.7266H12.9082V14.2734H15.6372V15.3589H12.9082V16.9102H15.8701V18H11.5898V11.6367ZM16.1341 11.6367H17.5712L18.639 16.084H18.6962L19.8607 11.6367H21.1087L22.2777 16.0972H22.3304L23.3983 11.6367H24.8353L23.0204 18H21.724L20.5111 13.7988H20.4628L19.2455 18H17.9535L16.1341 11.6367Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBrandIcon);
export default __webpack_public_path__ + "static/media/new-brand-icon.626845f16cfc3b8177311a11400174d2.svg";
export { ForwardRef as ReactComponent };